import { API_ENDPOINTS, API_ERROR_CODES } from "shared/constants";
import { APIService } from "shared/services";
import { IAPIError, IDataKeys, IJSONAPIItem } from "shared/types";

interface IJSONAPIAccommodationRoom {
  [key: string]: IJSONAPIItem;
}

export interface IJSONAPIAccommodationRoomCollection {
  [IDataKeys.eventAccommodationRoom]: IJSONAPIAccommodationRoom;
  meta: {
    [key: string]: IJSONAPIItem;
  };
  pagination: any;
}

export class EventAccommodationRoomService {
  static getEventAccommodationRoomsForBlock = (
    id: string
  ): Promise<IJSONAPIAccommodationRoomCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response = await APIService.get({
          path: API_ENDPOINTS.EVENT_ACCOMMODATION_ROOMS,
          data: {
            "roomType.accommodationBlock":
              API_ENDPOINTS.EVENT_ACCOMMODATION_BLOCK(id),
            itemsPerPage: 50,
          },
        });

        resolve(response);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(
          API_ERROR_CODES.GET_EVENT_ACCOMMODATION_ROOMS
        );
        return reject(error);
      }
    });
}
